import React from 'react';

import Header from '../../header/header';
import SalePageTabs from '../../sale-page/components/sale-page-tabs';
import { withError } from '../../shared/components/error-boundary';

export default withError(({ pgList, currentPG, fixedHeader, scrollTop, slug, basename, isV2 }) => {
    const tabs = pgList.map(pg => {
        const { tabLink } = pg;
        let [ vanityUrl, , key ] = pg.key.split(":");
        const path = `/${basename}/${vanityUrl}/${key}`;
        const className = (pg.name || "").toLowerCase().replace(/\s+/g, '-') + " " + (pg.name || "").toLowerCase(); //temp css styling to avoid breaking old targeting
        const identifier = pg.key;
        const icon = pg.fontIcon;
        //pass along preview and pStoreID parameter when switching tabs
        const { _preview,pStoreID } = pg.search;

        return {
            path,
            name: pg.name,
            className,
            identifier,
            onTabClick: scrollTop,
            tabLink,
            icon,
            search: {_preview,pStoreID}
        };
    });

    const headerProps = {
        tabs,
        fixedHeader,
        selectedTab: currentPG,
    }

    return isV2 ? <SalePageTabs {...headerProps} /> : <Header  {...headerProps} />
});